// API Configuration
// Change this URL to your production backend when deploying!
export const API_BASE_URL = "https://al-sadik.com"; // Production API endpoint (no trailing slash)
// export const API_BASE_URL = "http://localhost/alsadik"; // Development API endpoint

// You can also add other API-related configurations here
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: "/api/auth/login",
  REGISTER: "/api/auth/register",
  LOGOUT: "/api/auth/logout",
  REFRESH_TOKEN: "/api/auth/refresh",
  
  // User management
  USER_PROFILE: "/api/user/profile",
  UPDATE_PROFILE: "/api/user/update",
  GET_USER_DETAILS: "/api/get_user_details.php",
  
  // Protected endpoints
  PRODUCTS: "/api/products.php",
  
  // Add more endpoints as needed
  // PRODUCTS: "/api/products",
  // ORDERS: "/api/orders",
};

// API configuration options
export const API_CONFIG = {
  timeout: 10000, // 10 seconds
  headers: {
    'Content-Type': 'application/json',
  },
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

/**
 * Make an authenticated API request with automatic token handling
 * Import apiTokenService dynamically to avoid circular dependencies
 */
export const authenticatedFetch = async (url, options = {}) => {
  // Dynamically import to avoid circular dependency issues
  const { default: apiTokenService } = await import('../services/apiTokenService');
  return apiTokenService.fetch(url, options);
};

// For development, you might want to use a local server
// Uncomment the line below for local development
// export const API_BASE_URL = "http://localhost:3001"; // Local development API
